<template>
    <div class="auth-wrapper auth-v1 px-2 hyper-login">
        <div class="auth-inner py-2">

            <!-- Forgot Password v1 -->
            <b-card class="mb-0">
                <b-link class="brand-logo">
                    <h2 class="brand-text" style="margin:auto 0">
                        Hyper<span style="font-size:xx-large">Auth</span>
                    </h2>
                </b-link>
                <b-card-title class="mb-1">
                    Forgot Password?
                    <feather-icon
                        class="text-warning"
                        icon="LockIcon"
                        size="17"
                    />
                </b-card-title>
                <b-card-text class="mb-2">
                    Enter your email and we'll send you instructions to reset your password
                </b-card-text>

                <!-- form -->
                <validation-observer ref="simpleRules">
                    <b-form
                        class="auth-forgot-password-form mt-2"
                        @submit.prevent="validationForm"
                    >
                        <!-- email -->
                        <b-form-group
                            label-for="forgot-password-email"
                        >
                            <validation-provider
                                #default="{ errors }"
                                name="Email"
                                rules="required|email"
                            >
                            <b-form-input
                                id="forgot-password-email"
                                v-model="userEmail"
                                :state="errors.length > 0 ? false:null"
                                name="forgot-password-email"
                                placeholder="Email Address"
                            />
                            <small class="text-danger">
                                {{ errors[0] }}
                            </small>
                            </validation-provider>
                        </b-form-group>

                        <!-- submit button -->
                        <b-button
                            variant="primary"
                            block
                            type="submit"
                        >
                            Send reset link
                        </b-button>
                    </b-form>
                </validation-observer>

                <b-card-text class="text-center mt-2">
                    <b-link :to="{name:'auth-login'}">
                        <feather-icon icon="ChevronLeftIcon" />
                        Back to login
                    </b-link>
                </b-card-text>

            </b-card>
        <!-- /Forgot Password v1 -->
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { mapActions } from 'vuex'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data () {
        return {
            userEmail: '',
            required,
            email
        }
    },
    methods: {
        ...mapActions([
            'resetPassword'
        ]),
        validationForm () {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.resetPassword({ email: this.userEmail })
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
div .hyper-login:after {
  content: '';
  width: 100%;
  height: 100vh;
  position: absolute;
  opacity: 0.6;
  background-image: url('../assets/images/pages/login/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}
</style>
